import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { NavLink } from "react-router-dom";
import './style.css';

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/',
    },
    {
        id: 2,
        title: 'Services',
        link: '#',
        submenu: [
            {
                id: 21,
                title: 'Daily Prayers',
                link: '/service-single/Daily-Prayers'
            },
            {
                id: 22,
                title: 'Islamic Education',
                link: '/service-single/Islamic-Education'
            },
            {
                id: 23,
                title: 'Community Support',
                link: '/service-single/Community-Support'
            },
            {
                id: 24,
                title: 'Youth Programmes',
                link: '/service-single/Youth-Programmes'
            },
            {
                id: 25,
                title: 'Community Events',
                link: '/service-single/Community-Events'
            },
        ]
    },
    {
        id: 3,
        title: 'Events',
        link: '#',
        submenu: [
            {
                id: 31,
                title: 'Jumu\'ah Prayer',
                link: '/event-single/Jumuah-Prayer'
            },
            {
                id: 32,
                title: 'Quran Classes',
                link: '/event-single/Quran-Classes'
            },
            {
                id: 33,
                title: 'Community Iftar',
                link: '/event-single/Community-Iftar'
            },
            {
                id: 34,
                title: 'Eid Celebration',
                link: '/event-single/Eid-Celebration'
            },
            {
                id: 35,
                title: 'Youth Programme',
                link: '/event-single/Youth-Programme'
            },
            {
                id: 36,
                title: 'Sisters Circle',
                link: '/event-single/Sisters-Circle'
            },
        ]
    },
    {
        id: 4,
        title: 'About Us',
        link: '/about',
    },
    {
        id: 5,
        title: 'Wall of Akhirah',
        link: '/wall-of-akhirah',
    },
    {
        id: 6,
        title: 'Contact Us',
        link: '/contact',
    }
]


const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        return (
                            <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                                {item.submenu ?
                                    <Fragment>
                                        <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                            <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                        </p>
                                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                            <List className="subMenu">
                                                <Fragment>
                                                    {item.submenu.map((submenu, i) => {
                                                        return (
                                                            <ListItem key={i}>
                                                                <NavLink onClick={ClickHandler} className="active"
                                                                    to={submenu.link}>{submenu.title}</NavLink>
                                                            </ListItem>
                                                        )
                                                    })}
                                                </Fragment>
                                            </List>
                                        </Collapse>
                                    </Fragment>
                                    : <NavLink className="active"
                                        to={item.link}>{item.title}</NavLink>
                                }
                            </ListItem>
                        )
                    })}
                </ul>

            </div>

            <div className="showmenu mobail-menu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu;